import {mapState} from 'vuex'

export default {
    name: 'ProductFilter',
    data() {
        return {
            search: '',
            fetchSearched: ''
        }
    },
    computed: {
        ...mapState({
            tags: state => state.products.tags,
            activeTags: state => state.products.activeTags,
            totalResults: state => state.products.totalProducts
        })
    },
    methods: {
        searchProducts() {
            this.$store.commit('products/setCurrentPage', 0)
            this.$emit('searched', this.search)
            this.fetchSearched = this.search
            this.$gtag.event('search-products-click', {
                'event_category': 'products',
                'event_label': 'Search Products',
                'value': this.search
            })
        },

        clearSearchInput() {
            this.search = "";
            this.fetchSearched = "";
            this.searchProducts()
        },

        filterOnTag(currentTag) {
            this.$store.commit('products/setActiveTag', currentTag.id);
            this.$store.commit('products/setCurrentPage', 0)
            this.$store.dispatch('products/retrieveProducts');
            this.$gtag.event('filter-products-click', {
                'event_category': 'products',
                'event_label': 'Filter Products Button Clicked',
                'value': currentTag.id
            })
        },

        isTagActive(tag) {
            return this.activeTags.includes(tag.id)
        }
    },
    created() {
        this.$store.dispatch('products/retrieveTags');
    }
}